import React, { useEffect, useRef } from 'react';
import './Hero.css';

const Hero = () => {
  const gridRef = useRef(null);

  useEffect(() => {
    const grid = gridRef.current;
    if (!grid) return;

    const handleMouseMove = (e) => {
      const rect = grid.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      grid.style.setProperty('--mx', `${x}%`);
      grid.style.setProperty('--my', `${y}%`);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <section id="hero" className="hero">
      <div className="hero-grid" ref={gridRef}></div>

      <div className="hero-content">
        <div className="hero-label">
          <span className="label-dot"></span>
          Trusted Source in IT Services
        </div>

        <h1 className="hero-title">
          <span className="title-line">Optimize</span>
          <span className="title-line accent">IT Systems</span>
          <span className="title-line">& Design</span>
        </h1>

        <div className="hero-sub">
          <p className="hero-description">
            Creating better technology solutions — preparing for your success through innovative,
            reliable, and high-quality IT services.
          </p>
          <div className="hero-actions">
            <a href="#contact" className="btn-primary">
              Meet With Us
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a href="#services" className="btn-ghost">Our Solutions</a>
          </div>
        </div>
      </div>

      <div className="hero-badge">
        <div className="badge-ring">
          <svg viewBox="0 0 120 120" className="badge-text-svg">
            <path id="circle-text" d="M 60,60 m -40,0 a 40,40 0 1,1 80,0 a 40,40 0 1,1 -80,0" fill="none"/>
            <text fontSize="9.5" fontFamily="DM Mono, monospace" fill="rgba(14,114,227,0.7)" letterSpacing="3.2">
              <textPath href="#circle-text">aXtion Technologies • aXtion Technologies •</textPath>
            </text>
          </svg>
          <div className="badge-center">
            <span className="badge-x">X</span>
          </div>
        </div>
      </div>

      <div className="hero-scroll">
        <div className="scroll-line"></div>
        <span>Scroll</span>
      </div>

      <div className="hero-stats">
        <div className="stat">
          <span className="stat-num">28+</span>
          <span className="stat-label">Years Experience</span>
        </div>
        <div className="stat-divider"></div>
        <div className="stat">
          <span className="stat-num">45K+</span>
          <span className="stat-label">Customers</span>
        </div>
        <div className="stat-divider"></div>
        <div className="stat">
          <span className="stat-num">24/7</span>
          <span className="stat-label">Support</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
